export default __webpack_public_path__ + "static/media/doc.670d5597.svg";